import {observer} from "mobx-react";
import {FilterSection} from "../Filters/FilterSection";
import * as React from "react";
import {useCallback, useContext} from "react";
import {AppStoreContext} from "../../Stores/AppStore";

export const ServiceFilters = observer(() => {
    const context = useContext(AppStoreContext);

    const _onFilterChange = useCallback(() => {
        void context.loadMeasurements();
        void context.loadComponents();
    }, [context]);

    return <FilterSection onFilterChange={_onFilterChange}/>;
});
